import { render } from "./AgreementView.vue?vue&type=template&id=3a937ff5&scoped=true"
const script = {}

import "./AgreementView.vue?vue&type=style&index=0&id=3a937ff5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a937ff5"]])

export default __exports__